import {
  getsalescataloge,
  getusercataloge,
  viewSalesCataloge,
  viewUserCataloge,
  editViewSAlesCataloge,
  updateSalesCataloge,
  editViewUserCataloge,
  updateUserCataloge,
  getSalesCatalogeMappingTemplate,
  getUserCatalogeMappingTemplate,
  createsalescataloge,
  createUsercataloge,
  deletesalescataloge,
} from "@/http/setup/catalogueMapping.js";

export default {
  namespaced: true,
  state: {
    catalogeList: [],
    userCatalogeList: [],
    viewSalesCatalogeList: {},
    viewUserCatalogeList: {},
    EditViewSalesCatalogeList: {},
    EditViewUserCatalogeList: {},
    CreateViewSalesCataloge: {},
    CreateViewUserCataloge: {},
    CreateSalesCataloge: null,
    CreateUserCataloge: null,
  },
  actions: {
    async setsalescataloge({ commit }) {
      try {
        const resp = await getsalescataloge();
        commit("SET_SALES_CATALOGE", resp.data.pageItems);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setUserCataloge({ commit }) {
      try {
        const resp = await getusercataloge();
        commit("SET_USER_CATALOGE", resp.data.pageItems);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setviewSalesCataloge({ commit }, id) {
      try {
        const resp = await viewSalesCataloge(id);
        commit("SET_VIEW_SALES_CATALOGE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setviewUserCataloge({ commit }, id) {
      try {
        const resp = await viewUserCataloge(id);
        commit("SET_VIEW_USER_CATALOGE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async seteditViewSAlesCataloge({ commit }, id) {
      try {
        const resp = await editViewSAlesCataloge(id);
        commit("SET_EDIT_VIEW_SALES_CATALOGE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateSalesCatalogeAction({ commit }, data) {
      try {
        const resp = await updateSalesCataloge(data.id, data.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async seteditViewUserCataloge({ commit }, id) {
      try {
        const resp = await editViewUserCataloge(id);
        commit("SET_EDIT_VIEW_USER_CATALOGE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateUserCatalogeAction({ commit }, data) {
      try {
        const resp = await updateUserCataloge(data.id, data.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setSalesCatalogeMappingTemplate({ commit }) {
      try {
        const resp = await getSalesCatalogeMappingTemplate();
        commit("SET_SALES_CATALOGE_MAPPING_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setUserCatalogeMappingTemplate({ commit }) {
      try {
        const resp = await getUserCatalogeMappingTemplate();
        commit("SET_USER_CATALOGE_MAPPING_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createsalescatalogeAction({ commit }, data) {
      try {
        const resp = await createsalescataloge(data);
        commit("CREATE_SALES_CATALOGE_ACTION", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createUsercatalogeAction({ commit }, data) {
      try {
        const resp = await createUsercataloge(data);
        commit("CREATE_USER_CATALOGE_ACTION", resp.data.resourceId);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deletesalescatalogeAction({ commit }, data) {
      try {
        const resp = await deletesalescataloge(data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_SALES_CATALOGE(state, payload) {
      state.catalogeList = payload;
    },
    SET_USER_CATALOGE(state, payload) {
      state.userCatalogeList = payload;
    },
    SET_VIEW_SALES_CATALOGE(state, payload) {
      state.viewSalesCatalogeList = payload;
    },
    SET_VIEW_USER_CATALOGE(state, payload) {
      state.viewUserCatalogeList = payload;
    },
    SET_EDIT_VIEW_SALES_CATALOGE(state, payload) {
      state.EditViewSalesCatalogeList = payload;
    },
    SET_EDIT_VIEW_USER_CATALOGE(state, payload) {
      state.EditViewUserCatalogeList = payload;
    },
    SET_SALES_CATALOGE_MAPPING_TEMPLATE(state, payload) {
      state.CreateViewSalesCataloge = payload;
    },
    SET_USER_CATALOGE_MAPPING_TEMPLATE(state, payload) {
      state.CreateViewUserCataloge = payload;
    },
    CREATE_SALES_CATALOGE_ACTION(state, payload) {
      state.CreateSalesCataloge = payload;
    },
    CREATE_USER_CATALOGE_ACTION(state, payload) {
      state.CreateUserCataloge = payload;
    },
  },
  getters: {
    getCatalogeList(state) {
      return state.catalogeList;
    },
    getUserCatalogeList(state) {
      return state.userCatalogeList;
    },
  },
};
